// @flow
import React, { Component, Fragment } from "react";
import classNames from "classnames";
import Popover from "@material-ui/core/Popover";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import HelpIcon from "@material-ui/icons/Help";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../types/GeneralTypes";
import type { IconStylesClassesType } from "../../../styles/iconStyles";
import { iconStyles } from "../../../styles/iconStyles";
import { tableStyles } from "../../../styles/generalStyles";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...iconStyles(theme),
  ...tableStyles(theme),
  popover: {
    pointerEvents: "none"
  },
  paper: {
    padding: theme.spacing.unit
  }
});

type TextReplaceHelperPropsType = {
  classes: {
    ...IconStylesClassesType,
    popover: DictionaryType,
    paper: DictionaryType
  }
};

type TextReplaceHelperStatesType = {
  anchorEl: *
};

class TextReplaceHelper extends Component<
  TextReplaceHelperPropsType,
  TextReplaceHelperStatesType
> {
  constructor(props: TextReplaceHelperPropsType) {
    super(props);
    this.state = {
      anchorEl: null
    };
  }

  handleOpen = (event: Event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render(): React$Element<*> {
    const classes = this.props.classes;
    const anchorEl = this.state.anchorEl;

    return (
      <Fragment>
        <HelpIcon
          className={classes.shineIcon}
          onMouseEnter={this.handleOpen}
          onMouseLeave={this.handleClose}
        />
        <Popover
          className={classes.popover}
          classes={{
            paper: classes.paper
          }}
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
          onClose={this.handleClose}
        >
          <Table className={classNames(classes.appTable, classes.noBorder)}>
            <TableBody>
              <TableRow>
                <TableCell padding="dense" className={classes.border}>
                  [[Person]]
                </TableCell>
                <TableCell padding="dense" className={classes.normal}>
                  Person identified that raised the alert
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell padding="dense" className={classes.border}>
                  [[Time]]
                </TableCell>
                <TableCell padding="dense" className={classes.normal}>
                  Timestamp of when the alert is raised
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell padding="dense" className={classes.border}>
                  [[AlertName]]
                </TableCell>
                <TableCell padding="dense" className={classes.normal}>
                  Name of the alert
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell padding="dense" className={classes.border}>
                  [[Probability]]
                </TableCell>
                <TableCell padding="dense" className={classes.normal}>
                  Probability of match in percentage
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  padding="dense"
                  className={classes.normal}
                  colSpan={2}
                >
                  Examples:
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;[[Person]] was seen at [[Time]].
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;[[Person]] [[Probability]]
                  [[AlertName]].
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Popover>
      </Fragment>
    );
  }
}

export default withStyles(styles)(TextReplaceHelper);
